import CompaniesWrapper from "./components/home/CompaniesWrapper";
import CurrentProbremWrapper from "./components/home/CurrentProbremWrapper";
import EnjoyLiftMessageWrapper from "./components/home/EnjoyLiftMessageWrapper";
import FeaturesWrapper from "./components/home/FeaturesWrapper";
import HowToUseWrapper from "./components/home/HowToUseWrapper";
import MainWrapper from "./components/home/MainWrapper";
import PerformanceWrapper from "./components/home/PerformanceWrapper";
import ProductPriceWrapper from "./components/home/ProductPriceWrapper";
import ResolveProbremMessageWrapper from "./components/home/ResolveProbremMessageWrapper";
import SleepDeptWrapper from "./components/home/SleepDeptWrapper";
import ContactWrapper from "./components/home/ContactWrapper";
import FloatingButton from "./components/FloatingButton";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <div className="App">
      <MainWrapper />
      <EnjoyLiftMessageWrapper />
      <SleepDeptWrapper />
      <CurrentProbremWrapper />
      <ResolveProbremMessageWrapper />
      <HowToUseWrapper />
      <FeaturesWrapper />
      <PerformanceWrapper />
      <CompaniesWrapper />
      {/* <ReviewWrapper /> */}
      <ProductPriceWrapper />
      <ContactWrapper />
      {/* <CompanyInfo /> */}
      {/* <FAQWrapper /> */}

      <FloatingButton />

      <Toaster />
    </div>
  );
}

export default App;
